import { __spreadArrays } from "tslib";
import { mapKeys, upperFirst } from 'lodash';
export var getHighestQualityVideo = function (videos) {
    var mp4 = videos.filter(function (video) { return video.format === 'mp4'; });
    return mp4.reduce(function (result, video) { return (parseInt(video.quality, 10) > parseInt(result.quality, 10) ? video : result); }, mp4[0]);
};
export var createToolbarTheme = function (toolbarName, theme) {
    return mapKeys(theme, function (value, key) { return "" + toolbarName + upperFirst(key); });
};
export var moveArrayItemBeforeTargetItem = function (arr, movedItemVal, targetItemVal) {
    var newArr = __spreadArrays(arr);
    var movelItemIndex = newArr.indexOf(movedItemVal);
    if (movelItemIndex === -1) {
        return arr;
    }
    newArr.splice(movelItemIndex, 1);
    var targetItemIndex = newArr.indexOf(targetItemVal);
    if (targetItemIndex === -1) {
        return arr;
    }
    newArr.splice(targetItemIndex, 1, movedItemVal, targetItemVal);
    return newArr;
};
